import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ReactPlayer from 'react-player';
import { isSSR } from 'wix-rich-content-common';
import { pauseTrigger } from './constants.js';
import 'ricos-schema';

var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
const VIMEO_SDK_URL = "https://player.vimeo.com/api/player.js";
const VIMEO_GLOBAL = "Vimeo";
class ReactPlayerWrapper extends Component {
  constructor(props) {
    super(props);
    __publicField(this, "isVimeoAndRequireJS", () => !isSSR() && isVimeoUrl(this.props.url) && !window[VIMEO_GLOBAL] && window.requirejs);
    __publicField(this, "handleAutoPlay", () => {
      var _a;
      if (window == null ? void 0 : window.IntersectionObserver) {
        const intersectionObserver = new IntersectionObserver((entries) => {
          const { disabled } = this.props;
          entries.forEach((entry) => {
            const startAutoPlay = entry.isIntersecting && !disabled && !this.state.isAutoPlayPaused;
            if (startAutoPlay) {
              this.handlePlay();
            } else {
              this.handlePause(pauseTrigger.scroll);
            }
          });
        });
        const reactPlayerElement = (_a = this.playerRef) == null ? void 0 : _a.current.wrapper;
        intersectionObserver.observe(reactPlayerElement);
      }
    });
    __publicField(this, "handlePlay", () => {
      if (!this.state.isPlaying) {
        this.setState({ isPlaying: true });
      }
    });
    __publicField(this, "handlePause", (trigger) => {
      if (this.state.isPlaying) {
        const isAutoPlayPaused = trigger !== pauseTrigger.scroll;
        this.setState({ isPlaying: false, isAutoPlayPaused });
      }
    });
    __publicField(this, "onWrapperClick", () => {
      if (this.props.isCustomVideo && !this.props.controls) {
        this.state.isPlaying ? this.handlePause() : this.handlePlay();
      }
    });
    this.playerRef = React.createRef();
    this.state = {
      vimeoLoaded: false,
      isPlaying: false,
      isAutoPlayPaused: false
    };
  }
  componentDidMount() {
    if (this.isVimeoAndRequireJS()) {
      window.require([VIMEO_SDK_URL], (player) => {
        window.Vimeo = { Player: player };
        this.setState({ vimeoLoaded: true });
      });
    }
    if (this.props.autoPlay) {
      this.handleAutoPlay();
    }
  }
  render() {
    if (!this.state.vimeoLoaded && this.isVimeoAndRequireJS()) {
      return null;
    }
    const {
      isPlayable,
      styles,
      disabled,
      onReady,
      onDuration,
      onProgress,
      url,
      width,
      height,
      progressInterval,
      config,
      muted,
      isLoaded,
      controls,
      className,
      onContextMenu,
      loop
    } = this.props;
    return (
      // eslint-disable-next-line jsx-a11y/no-static-element-interactions
      /* @__PURE__ */ React.createElement(
        "div",
        {
          tabIndex: 0,
          onClick: this.onWrapperClick,
          onKeyDown: (e) => {
            if (e.key === "Enter") {
              this.onWrapperClick();
            }
          },
          "data-hook": "reactPlayerWrapper"
        },
        /* @__PURE__ */ React.createElement(
          ReactPlayer,
          {
            playing: this.state.isPlaying && !disabled,
            onPlay: this.handlePlay,
            onPause: this.handlePause,
            controls,
            style: styles,
            light: !isPlayable,
            onReady,
            url,
            width,
            height,
            onDuration,
            onProgress,
            progressInterval,
            config,
            muted,
            "data-loaded": isLoaded,
            className,
            onContextMenu,
            ref: this.playerRef,
            loop
          }
        )
      )
    );
  }
}
ReactPlayerWrapper.propTypes = {
  url: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  isPlayable: PropTypes.bool,
  styles: PropTypes.object,
  onReady: PropTypes.func,
  onDuration: PropTypes.func,
  onProgress: PropTypes.func,
  progressInterval: PropTypes.number,
  config: PropTypes.object,
  width: PropTypes.String,
  height: PropTypes.String,
  muted: PropTypes.bool,
  isLoaded: PropTypes.bool,
  controls: PropTypes.bool,
  loop: PropTypes.bool,
  autoPlay: PropTypes.bool,
  isCustomVideo: PropTypes.bool,
  className: PropTypes.string,
  onContextMenu: PropTypes.func
};
ReactPlayerWrapper.defaultProps = {
  isPlayable: true
};
function isVimeoUrl(url) {
  const MATCH_URL = /vimeo\.com\/.+/;
  const MATCH_FILE_URL = /vimeo\.com\/external\/[0-9]+\..+/;
  return !MATCH_FILE_URL.test(url) && MATCH_URL.test(url);
}

export { ReactPlayerWrapper as default };
//# sourceMappingURL=reactPlayerWrapper.js.map
